var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          staticClass: "project-detail-drawer",
          attrs: {
            visible: _vm.visible,
            "with-header": true,
            title: "项目详情",
            size: _vm.drawerSize,
            direction: "rtl",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "drawer-content",
            },
            [
              _c("div", { staticClass: "project-number" }, [
                _vm._v("项目编号：" + _vm._s(_vm.projectDetail.id)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("基本信息"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-content" }, [
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("项目类型："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.projectType)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("项目名称："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.projectName)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("项目ID："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.id)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("项目状态："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "item-value" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getTagType(_vm.projectDetail.status),
                                size: "medium",
                                effect: "light",
                              },
                            },
                            [
                              _vm.projectDetail.status === "已发放"
                                ? _c("i", { staticClass: "el-icon-check" })
                                : _vm.projectDetail.status.includes(
                                    "已生成订单"
                                  )
                                ? _c("i", { staticClass: "el-icon-tickets" })
                                : _vm.projectDetail.status === "待发放"
                                ? _c("i", { staticClass: "el-icon-time" })
                                : _vm.projectDetail.status === "作废" ||
                                  _vm.projectDetail.status === "已删除"
                                ? _c("i", { staticClass: "el-icon-warning" })
                                : _vm.projectDetail.status === "卡密生成中"
                                ? _c("i", { staticClass: "el-icon-loading" })
                                : _vm.projectDetail.status === "已确认"
                                ? _c("i", {
                                    staticClass: "el-icon-document-checked",
                                  })
                                : _vm.projectDetail.status === "已下单"
                                ? _c("i", {
                                    staticClass: "el-icon-shopping-cart-full",
                                  })
                                : _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.getStatusName(_vm.projectDetail.status)
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("关联ID："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.relativeId)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("关联编号："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.relatedNumber)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("福卡名称："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.cardName)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("单卡面值："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.parAmount)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("项目总金额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.totalAmount)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("项目可用余额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.availableAmount)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("生成卡片数量："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.cardCount)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("发放小程序："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.miniappName)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("归属客户："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.customerName)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("发放时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.issueTime)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("有效期："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.validTime)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("创建时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.createTime)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-row remark-row" }, [
                    _c("div", { staticClass: "detail-item full-width" }, [
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v("内部备注："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.projectDetail.remark || "无")),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }